<template>
  <div>
    <div
      class="well bg white flex items-stretch"
      style="padding:0;"
    >
      <div
        class="col-md-6"
        style="background-color:#eee;"
      >
        <div style="padding:19px;">
          <div class="flex flex-col justify-between">
            <div style="margin-bottom:2em;">
              <h2 class="flex items-center">
                <ion-icon
                  name="calculator"
                  style="margin-right:10px;"
                ></ion-icon>
                Estimate Calculator
              </h2>
              <p>How many units would you like to order? Enter your quantity here to estimate your pricing and see the impact of your participation on the group order. Once you are ready to participate, click 'Join Order'.</p>
              <fieldset>
                <label style="width:100%;font-size:1.5em;font-weight:normal;"> Your estimated quantity</label>
                <input
                  v-if="mode === 'print'"
                  type="text"
                  style="padding:0.35em 0.5em; font-size:2.5em; border-radius:3px; border:1px solid #eee; font-weight:100;"
                  class="w-full"
                  v-model="printQty"
                  @focus="printQty = ''"
                  @keypress="isNumber($event)"
                >
                <input
                  v-else
                  type="number"
                  style="padding:0.35em 0.5em; font-size:2.5em; border-radius:3px; border:1px solid #eee; font-weight:100;"
                  class="w-full"
                  v-model="digitalQty"
                  @focus="digitalQty = ''"
                  @keypress="isNumber($event)"
                >
              </fieldset>
            </div>

            <div v-if="mode === 'print'">
              <label style="width:100%;font-size:1.5em;font-weight:normal;">Current demand from other buyers</label>
              <div style="border-radius: 0.1em; border:1px solid #eeeeee; padding:0.25em 0.5em; background-color:#f5f5f5; color: #8f8fa9; font-weight:300; font-size:2.5em;">{{ this.totalOtherParticipantPrintEstimates }}</div>
            </div>
            <div v-else>
              <label style="width:100%;font-size:1.5em;font-weight:normal;">Current demand from other buyers</label>
              <div style="border-radius: 0.1em; border:1px solid #eeeeee; padding:0.25em 0.5em; background-color:#f5f5f5; color: #8f8fa9; font-weight:300; font-size:2.5em;">{{ this.totalOtherParticipantDigtialEstimates }}</div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div style="padding:21px;">
          <div
            class="relative"
            style="margin:15px 0 0 15px; z-index:10"
          >
            <button
              @click="mode = 'print'"
              class="tab"
              style="padding:0.5em 1em; font-size:1em; margin-right:0.5em"
              :class="{'btn-ghost-active': mode === 'print', 'btn-ghost-inactive': mode === 'digital'}"
              v-if="order.items[0].print"
            >
              Print Estimates
            </button>
            <button
              @click="mode = 'digital'"
              class="tab"
              style="padding:0.5em 1em; font-size:1em; margin-right:0.5em"
              :class="{'btn-ghost-active': mode === 'digital', 'btn-ghost-inactive': mode === 'print'}"
              v-if="order.items[0].digital"
            >
              Digital Estimates
            </button>
          </div>

          <div
            class="well relative"
            style="margin-top:-2px; z-index:5;"
          >
            <div
              class="flex items-end relative"
              style="width:100%;border-bottom:1px solid #eee; padding:4px 0; z-index:10"
            >
              <div class="col-md-5 font-bold text mid-gray">
                Aggregated Quantity
              </div>
              <div class="col-md-3 text-right font-bold text mid-gray">
                Per Unit
              </div>
              <div class="col-md-4 text-center font-bold text mid-gray">

              </div>
            </div>
            <div
              class="flex relative items-center"
              :class="{'current-estimate': parseFloat(estimate.ppu, 2) === currentPPU }"
              style="border-bottom:1px solid #eee; padding:4px 0; z-index:10;"
              v-for="(estimate, key) in estimates"
              :key="key"
            >
              <div class="col-md-5">
                {{estimate.quantity }}
              </div>
              <div
                class="col-md-3 text-right"
                :class="{'current-estimate': parseFloat(estimate.ppu, 2) === currentPPU }"
              >
                {{ new Intl.NumberFormat('us-US', { style: 'currency', currency: 'USD' }).format(estimate.ppu) }}
              </div>
              <div
                class="col-md-4 text-center"
                style="padding:4px; background-color:#cee9c1; color:#214a0e"
                v-if="parseFloat(estimate.ppu, 2) === currentPPU"
              >
                Current Rate
              </div>
            </div>
          </div>

          <div style="font-size:1.25em;">
            <div
              class="flex"
              v-if="this.currentPPU"
            >
              <div class="col-md-4">
                Your Quantity
              </div>
              <div class="col-md-3 text-center">
                Per Unit
              </div>
              <div class="col-md-5 flex justify-end items-center">
                Estimated Price
                <div
                  class="flex items-center glyphicon description cursor-pointer"
                  style="padding-bottom: 2px;"
                  @click="showDisclaimer = true"
                >
                  <ion-icon
                    name="information-circle"
                    style="margin-left:5px;"
                  ></ion-icon>
                </div>
              </div>
            </div>

            <div
              class="flex"
              style="font-size:1.5em; font-weight:100"
              v-if="this.currentPPU"
            >
              <div class="col-md-3">
                {{ this.quantity }}
              </div>
              <div class="col-md-1">
                x
              </div>
              <div class="col-md-3 text-center">
                {{ new Intl.NumberFormat('us-US', { style: 'currency', currency: 'USD' }).format(this.currentPPU) }}
              </div>
              <div class="col-md-1">
                =
              </div>
              <div class="col-md-4 text-right">
                {{ this.totalEstimatedAmount }}
              </div>
            </div>
            <div
              v-else-if="printQty !== 0"
              class="text-center"
              style="font-size:1.5em; font-weight:100; margin-top:1em;"
            >
              Your quantity is a little low for our estimate<br> calculator
              <span
                class="glyphicon description cursor-pointer"
                style="font-size:1em;"
                @click="showDisclaimer = true"
              >
                <ion-icon name="information-circle"></ion-icon>
              </span>, but you can still join <span
                class="glyphicon description"
                style="font-size:1em;"
              >
                <ion-icon name="checkmark-circle-outline"></ion-icon>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      v-if="showDisclaimer"
      @close="showDisclaimer = false"
    >
      <div>
        <div
          @click="showDisclaimer = false"
          class="absolute cursor-pointer"
          style="top:0; right:15px; font-size:2em;"
        >
          <ion-icon name="close"></ion-icon>
        </div>
        <h2
          class="mb"
          style="margin-top:0;padding-right:2em;"
        >About Pricing and this Calculator</h2>
        <p>Your estimated price is based on the current aggregated demand from you and other buyers in your organization. As the demand increases, the rate will decrease according to the estimates provided. Estimated pricing is subject to change and does not include shipping costs and/or miscellaneous charges. On average, shipping estimates amount to an additional 10-15% of your reprint cost. All charges will be presented with your Final Estimate at the conclusion of the aggregation period.</p>
        <p style="margin-bottom:0;"> If you are one of the early participants, your quantity may not exceed the lowest quantity listed in our estimates. As a result, your estimated pricing may be temporarily unavailable. However, you can still track group participation and rates after you join and therefore calculate the progression of your pricing throughout the aggregation.</p>
      </div>
    </modal>
  </div>

</template>

<script>
export default {
  name: 'ReprintCalculator',
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mode: 'print',
      printQty: 0,
      digitalQty: 0,
      showDisclaimer: false,
    };
  },
  mounted() {
    if(!this.order.items[0].print) {
      this.mode = 'digital';
    }
  },
  computed: {
    estimates() {
      if (this.mode === 'print') {
        return this.order.items[0].print_estimates;
      }
      return this.order.items[0].digital_views_estimates;
    },
    quantity() {
      if (this.mode === 'print') {
        return this.printQty;
      }
      return this.digitalQty;
    },
    item() {
      return this.order.items[0];
    },
    totalOtherParticipantPrintEstimates() {
      return this.item.printEstimateTotal;
    },
    totalOtherParticipantDigtialEstimates() {
      return this.item.digitalEstimateTotal;
    },
    totalPrintEstimates() {
      return parseInt(this.printQty, 0) + parseInt(this.totalOtherParticipantPrintEstimates, 0);
    },
    totalDigitalEstimates() {
      return parseInt(this.digitalQty, 0) + parseInt(this.totalOtherParticipantDigtialEstimates, 0);
    },
    currentPPU() {
      if (this.mode === 'print') {
        return this.currentPrintPPU;
      }
      return this.currentDigitalPPU;
    },
    currentPrintPPU() {
      let ppu = null;

      for (let i = 0; i < this.item.print_estimates.length; i++) {
        const estimate = this.item.print_estimates[i];
        if (estimate.quantity <= this.totalPrintEstimates) {
          ppu = parseFloat(estimate.ppu, 2);
        }
      }
      return ppu;
    },
    currentDigitalPPU() {
      let ppu = null;

      for (let i = 0; i < this.item.digital_views_estimates.length; i++) {
        const estimate = this.item.digital_views_estimates[i];
        if (estimate.quantity <= this.totalDigitalEstimates) {
          ppu = parseFloat(estimate.ppu, 2);
        }
      }
      return ppu;
    },
    totalEstimatedAmount() {
      return new Intl.NumberFormat('us-US', { style: 'currency', currency: 'USD' }).format(this.quantity * this.currentPPU);
    },
  },
  methods: {
    isNumber(e) {
      const evt = (e) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
